import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Waiting from '@/components/order/Waiting'
import HotelList from '@/components/hotelsearch/HotelList'
import TextHotelList from '@/components/hotelsearch/TextHotelList'
import HotelDetail from '@/components/hotelsearch/HotelDetail'
// import WriteOrder from '@/components/order/WriteOrder'
import bookingWriteOrder from '@/components/order/bookingWriteOrder'
import bookingWritePay from '@/components/order/bookingWritePay'
// import WritePay from '@/components/order/WritePay'
import MyTrip from '@/components/account/myTrip'
import tripDetail from '@/components/account/tripDetail'
import myAccount from '@/components/account/myAccount'
import myCollection from '@/components/account/myCollection'
import PayResult from '@/components/order/PayResult'
import PayCallbackResult from '@/components/order/PayCallbackResult'
import frequently from '@/components/question/frequently'
import policy from '@/components/question/policy'
import clause from '@/components/question/clause'
import aboutUs from '@/components/question/aboutUs'
import refundPolicy from '@/components/question/refundPolicy'
import contactUs from '@/components/question/contactUs'
import login from '@/components/login/login'
import OAuth2 from '@/components/login/module/OAuth2'
import wechatLogin from '@/components/login/module/wechatLoginPage'
import googleLogin from '@/components/login/module/googleLoginPage'
import facebookLogin from '@/components/login/module/facebookLoginPage'
import appleLogin from '@/components/login/module/appleLoginPage'
import appleConfirm from '@/components/login/module/appleConfirmPage'
import register from '@/components/login/register'
import forgetPass from '@/components/login/forgetPass'
import resetPassword from '@/components/login/resetPassword'
import HotelSearch from '@/components/hotelsearch/HotelSearch'
import HotelSearchCond from '@/components/hotelsearch/HotelSearchCond'
import verifyUser from '@/components/account/verifyUser'
import WriteChildPay from '@/components/order/WriteChildPay'
import PayDisabled from '@/components/order/PayDisabled'
import WaitingChild from '@/components/order/WaitingChild'
import myCoupon from '@/components/account/myCoupon'
import Intercepting from '@/components/Intercepting'
import paymentSecondConfirm from '@/components/order/PaymentSecondConfirm'
import notFoundPage from '@/components/404'
import TTPage from '@/components/TTPage'

Vue.use(Router)

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Homes',
      component: Home,
      meta: {
        title: '首页',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/:querys',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/order/Waiting/:querys',
      name: 'Waiting',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: Waiting,
      meta: {
        title: '预订等待',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/hotelsearch/HotelList/:querys',
      name: 'HotelList',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: HotelList,
      meta: {
        title: '酒店列表',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/hotelsearch/HotelSearch/:querys',
      name: 'HotelSearch',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: HotelSearch,
      meta: {
        title: '酒店搜索',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/hotelsearch/HotelSearchCond/:querys',
      name: 'HotelSearchCond',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: HotelSearchCond,
      meta: {
        title: '搜索条件',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/hotelsearch/HotelDetail/:querys',
      name: 'HotelDetail',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: HotelDetail,
      meta: {
        title: '酒店详情',
        keepAlive: true,
        isBack: false
      }
    },
    // {
    //   path: '/order/WriteOrder',
    //   name: 'WriteOrder',
    //   props: true, // 若个要解耦的 到组件中 props 中。
    //   component: WriteOrder,
    //   meta: {
    //     title: '填写订单信息',
    //     keepAlive: true,
    //     isBack: false
    //   }
    // },
    {
      path: '/order/WriteOrder/:querys',
      name: 'WriteOrder',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: bookingWriteOrder,
      meta: {
        title: '填单及支付合并页',
        keepAlive: true,
        isBack: false
      }
    },
    // {
    //   path: '/order/WritePay',
    //   name: 'WritePay',
    //   props: true, // 若个要解耦的 到组件中 props 中。
    //   component: WritePay,
    //   meta: {
    //     title: '填写订单支付',
    //     keepAlive: true,
    //     isBack: false
    //   }
    // },
    {
      path: '/order/WritePay/:querys',
      name: 'WritePay',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: bookingWritePay,
      meta: {
        title: '订单待支付页面',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/account/MyTrip/:querys',
      name: 'MyTrip',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: MyTrip,
      meta: {
        title: '我的行程',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/account/tripDetail/:querys',
      name: 'tripDetail',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: tripDetail,
      meta: {
        title: '行程详情',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/account/myAccount/:querys',
      name: 'myAccount',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: myAccount,
      meta: {
        title: '我的账户',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/account/myCollection/:querys',
      name: 'myCollection',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: myCollection,
      meta: {
        title: '我的收藏',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/order/PayResult/:querys',
      name: 'PayResult',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: PayResult,
      meta: {
        title: '订单结果页',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/order/PayCallbackResult/:querys',
      name: 'PayCallbackResult',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: PayCallbackResult,
      meta: {
        title: '订单结果页', // 回掉结果页面
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/question/frequently/:querys',
      name: 'frequently',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: frequently,
      meta: {
        title: '常见问题',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/question/policy/:querys',
      name: 'policy',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: policy,
      meta: {
        title: '隐私政策',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/question/clause/:querys',
      name: 'clause',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: clause,
      meta: {
        title: '服务条款',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/question/aboutUs/:querys',
      name: 'aboutUs',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: aboutUs,
      meta: {
        title: '关于我们',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/question/refundPolicy/:querys',
      name: 'refundPolicy',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: refundPolicy,
      meta: {
        title: 'Refund Policy',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/question/contactUs/:querys',
      name: 'contactUs',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: contactUs,
      meta: {
        title: '联系我们',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/login/login/:querys',
      name: 'login',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: login,
      meta: {
        title: '登录',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/login/wechatLogin/',
      name: 'wechatLogin',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: wechatLogin,
      meta: {
        title: '微信授权',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/login/OAuth2/',
      name: 'OAuth2',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: OAuth2,
      meta: {
        title: 'OAuth2授权',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/login/googleLogin/',
      name: 'googleLogin',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: googleLogin,
      meta: {
        title: 'google授权',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/login/facebookLogin/',
      name: 'facebookLogin',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: facebookLogin,
      meta: {
        title: 'google授权',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/login/appleConfirm',
      name: 'appleConfirm',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: appleConfirm,
      meta: {
        title: 'apple授权确认',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/login/appleLogin',
      name: 'appleLogin',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: appleLogin,
      meta: {
        title: 'apple授权',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/login/register/:querys',
      name: 'register',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: register,
      meta: {
        title: '注册',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/login/forgetPass/:querys',
      name: 'forgetPass',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: forgetPass,
      meta: {
        title: '忘记密码',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/login/resetPassword/:querys',
      name: 'resetPassword',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: resetPassword,
      meta: {
        title: '重置密码',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/account/verifyUser/:querys',
      name: 'verifyUser',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: verifyUser,
      meta: {
        title: '邮箱验证',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/order/WriteChildPay/:querys',
      name: 'WriteChildPay',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: WriteChildPay,
      meta: {
        title: '填写子订单支付',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/order/PayDisabled/:querys',
      name: 'PayDisabled',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: PayDisabled,
      meta: {
        title: '支付失效页',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/order/WaitingChild/:querys',
      name: 'WaitingChild',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: WaitingChild,
      meta: {
        title: '子订单支付结果页/:querys',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/hotelsearch/TextHotelList/:querys',
      name: 'TextHotelList',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: TextHotelList,
      meta: {
        title: '测试酒店列表',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/account/myCoupon/:querys',
      name: 'myCoupon',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: myCoupon,
      meta: {
        title: '优惠券',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/intercepting/:querys',
      name: 'intercepting',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: Intercepting,
      meta: {
        title: '拦截页面',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/order/paymentSecondConfirm/:querys',
      name: 'paymentSecondConfirm',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: paymentSecondConfirm,
      meta: {
        title: '支付成功二次确认页面',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/404/:querys',
      name: 'notFoundPage',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: notFoundPage,
      meta: {
        title: '404页面',
        keepAlive: true,
        isBack: false
      }
    },
    {
      path: '/TTPage/:querys',
      name: 'TTPage',
      props: true, // 若个要解耦的 到组件中 props 中。
      component: TTPage,
      meta: {
        title: '404页面',
        keepAlive: true,
        isBack: false
      }
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js